let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kCB37")).then(() => parcelRequire('eVNA1'));